<div class="profile-wrapper">
  <button nz-button nzType="text" class="close-btn" (click)="closeModal()">
    <span nz-icon nzType="close" nzTheme="outline"></span>
  </button>

  <nz-card class="hero-card">
    <div class="hero-copy">
      <h1>Customer Profile</h1>
    </div>
  </nz-card>

  <nz-card class="info-card">
    <h2 nz-typography>Customer Info</h2>
    <div class="info-grid">
      <div class="info-item">
        <span class="info-label">Customer ID</span>
        <span class="info-value">{{ customer?.crm_id || 'N/A' }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">Name</span>
        <span class="info-value">
          {{ (customer?.first_name || '') | titlecase }} {{ (customer?.last_name || '') | titlecase }}
        </span>
      </div>
      <div class="info-item">
        <span class="info-label">Phone</span>
        <span class="info-value">{{ customer?.phone_number || 'N/A' }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">Address</span>
        <span class="info-value">{{ customer?.address_line_1 || 'N/A' }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">City</span>
        <span class="info-value">{{ customer?.address_city || 'N/A' }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">State</span>
        <span class="info-value">{{ customer?.address_state || 'N/A' }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">Zip Code</span>
        <span class="info-value">{{ customer?.address_zip || 'N/A' }}</span>
      </div>
    </div>
  </nz-card>

  <ng-container *ngFor="let wo of (workOrders || [])">
    <nz-card class="section-card">
      <div class="section-head">
        <div>
          <h2>{{ wo?.provider || 'Work Order' | titlecase}} Details</h2>
        </div>
        <nz-tag [nzColor]="wo.status === 'active' || wo.status == 'Completed' ? 'green' :
            wo.status?.toLowerCase() === 'default' ? 'default' :
            (wo.status?.toLowerCase()?.includes('inactive') ? 'red' : 'gold')">
          {{ wo.status | titlecase }}
        </nz-tag>
      </div>

      <div class="button-row">
        <button nz-button nzType="primary" (click)="repModal(wo)" *ngIf="permission">Update Rep</button>
        <button nz-button nzType="default" (click)="showNoteModal(wo)">Add Note</button>
        <button nz-button nzType="default" (click)="openChargeModal(wo)"
          *ngIf="isProcessingFee(wo) && !isCharged(wo) && wo.status?.toLowerCase() !== 'waived'"
          [nzLoading]="chargeLoading && chargeSelectedWo?.id === wo?.id">
          Charge Fee
        </button>
        <button nz-button nzType="default" (click)="resync(wo)" *ngIf="wo.provider?.toLowerCase() === 'dish'"
          [nzLoading]="manualSyncLoading">
          Sync With Dish
        </button>
        <button nz-button nzType="default" nzSize="small" (click)="openDishNotes(wo)"
          *ngIf="wo.provider?.toLowerCase() === 'dish'"
          [nzLoading]="dishNotesLoading">
          <span nz-icon nzType="file-text" nzTheme="outline"></span>
          Dish Notes
        </button>
        <button nz-button nzType="default" nzSize="small" (click)="openDishPricing(wo)"
          *ngIf="wo.provider?.toLowerCase() === 'dish'"
          [nzLoading]="dishPricingLoading">
          <span nz-icon nzType="file-text" nzTheme="outline"></span>
          Dish Pricing
        </button>
        <button nz-button nzType="default" nzSize="small" (click)="openEditModal(wo)"
          *ngIf="wo.provider?.toLowerCase() === 'dish' && currentUser?.super_admin" [nzLoading]="editModalLoading">
          <span nz-icon nzType="edit" nzTheme="outline"></span>
          Edit Work Order
        </button>
        <button nz-button nzType="default" (click)="showDiscrepancyModal(wo)"
          *ngIf="!wo.generic?.discrepancy_review && wo.provider === 'Fidium'">
          Submit Discrepancy
        </button>
        <button nz-button nzType="default"(click)="refundFee(wo)" [nzLoading]="pfeeLoading" *ngIf="wo.provider === 'Processing Fee' && wo.status == 'charged' && permission">
          <span nz-icon nzType="file-text" nzTheme="outline"></span>
          Refund Fee
        </button>
        <button nz-button nzType="default" nzDanger (click)="showWaiveModal(wo)" 
          *ngIf="currentUser?.super_admin && (wo.provider?.toLowerCase() === 'processing fee') && wo.status !== 'waived'">
          Waive Fee
        </button>
      </div>

      <div class="info-grid">
        <div class="info-item">
          <span class="info-label">Work Order ID</span>
          <span class="info-value">{{ wo.crm_id || 'N/A' }}</span>
        </div>
        <div class="info-item" *ngIf="wo?.account_number">
          <span class="info-label">Account Number</span>
          <span class="info-value">{{ wo.account_number }}</span>
        </div>
        <div class="info-item" *ngIf="wo.order_id">
          <span class="info-label">Order ID</span>
          <span class="info-value">{{ wo.order_id }}</span>
        </div>
        <div class="info-item" *ngIf="wo.generic?.lead_type">
          <span class="info-label">Lead Type</span>
          <span class="info-value">{{ wo.generic?.lead_type }}</span>
        </div>
        <div class="info-item" *ngIf="wo.generic?.plan">
          <span class="info-label">Plan</span>
          <span class="info-value">{{ wo.generic?.plan }}</span>
        </div>
        <div class="info-item" *ngIf="wo.generic?.account_status_detail || wo.generic?.cancellation_reason">
          <span class="info-label">Status Detail</span>
          <span class="info-value">{{ wo.generic?.account_status_detail || wo.generic?.cancellation_reason }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">Sale Date</span>
          <span class="info-value">{{ wo.sale_date | date }}</span>
        </div>
        <div class="info-item" *ngIf="wo.install_date">
          <span class="info-label">Activation Date</span>
          <span class="info-value">{{ wo.install_date | date }}</span>
        </div>
        <div class="info-item" *ngIf="wo.chargeback_date">
          <span class="info-label">Disconnect Date</span>
          <span class="info-value">{{ wo.chargeback_date | date }}</span>
        </div>
        <div class="info-item" *ngIf="wo.generic?.cancellation_date || wo?.cancel_date">
          <span class="info-label">Cancel Date</span>
          <span class="info-value">
            <ng-container *ngIf="wo.generic?.cancellation_date">
              {{ wo.generic?.schedule_date | date }}
            </ng-container>
            <ng-container *ngIf="wo?.cancel_date">
              {{ wo?.cancel_date | date }}
            </ng-container>
          </span>
        </div>
        <div class="info-item" *ngIf="wo.generic?.schedule_date && !wo.install_date">
          <span class="info-label">Schedule Date</span>
          <span class="info-value">{{ wo.generic?.schedule_date | date }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">Last Update</span>
          <span class="info-value">{{ wo.update_date | date }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">Rep</span>
          <span class="info-value">{{ wo.rep | titlecase }}</span>
        </div>
        <div class="info-item" *ngIf="wo.provider.toLowerCase() == 't-fiber' && currentUser.super_admin">
          <label nz-checkbox [(ngModel)]="stopRepSync" (ngModelChange)="repSyncChange($event, wo)">Stop Rep Sync</label>
        </div>
      </div>

      <div class="notes-list" *ngIf="wo.generic?.provider_notes?.length">
        <h3>Provider Notes</h3>
        <nz-card *ngFor="let note of wo.generic?.provider_notes" class="note-card">
          <nz-card-meta [nzTitle]="(note.user || 'System message') + ' - ' + (note.date | date:'short')"
            [nzDescription]="note.content">
          </nz-card-meta>
        </nz-card>
      </div>
    </nz-card>

    <nz-card class="section-card" *ngIf="wo.generic?.discrepancy_review">
      <div class="section-head">
        <div>
          <h2>Discrepancy Details</h2>
        </div>
      </div>
      <div class="info-grid">
        <div class="info-item">
          <span class="info-label">Status</span>
          <span class="info-value">{{ wo.generic?.discrepancy_review.discrepancy | titlecase }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">Submitted</span>
          <span class="info-value">{{ wo.generic?.discrepancy_review.submitted_date | date }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">Completed</span>
          <span class="info-value">{{ wo.generic?.discrepancy_review.date_completed | date }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">Notes</span>
          <span class="info-value">{{ wo.generic?.discrepancy_review.result_notes || 'N/A' }}</span>
        </div>
      </div>
    </nz-card>
  </ng-container>

  <ng-container *ngIf="duplicates?.length">
    <nz-card class="section-card">
      <div class="section-head">
        <div>
          <h2>Duplicates</h2>
        </div>
      </div>
      <div class="duplicate-grid">
        <nz-card class="duplicate-card" *ngFor="let dup of (duplicates || [])">
          <div class="info-item">
            <span class="info-label">Provider</span>
            <span class="info-value">{{ dup.provider || 'Unknown' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">CRM ID</span>
            <span class="info-value">{{ dup.crm_id || 'N/A' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Account Number</span>
            <span class="info-value">{{ dup.order_id || 'N/A' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Status</span>
            <nz-tag [nzColor]="dup.status === 'active' || dup.status == 'Completed' ? 'green' :
              dup.status?.toLowerCase() === 'default' ? 'default' :
              (dup.status?.toLowerCase()?.includes('inactive') ? 'red' : 'gold')">
              {{ dup.status | titlecase }}
            </nz-tag>
          </div>
          <div class="info-item">
            <span class="info-label">Sale Date</span>
            <span class="info-value">{{ dup.sale_date | date }}</span>
          </div>
          <div class="info-item" *ngIf="dup.install_date">
            <span class="info-label">Install Date</span>
            <span class="info-value">{{ dup.install_date | date }}</span>
          </div>
          <div class="info-item" *ngIf="dup.chargeback_date">
            <span class="info-label">Chargeback</span>
            <span class="info-value">{{ dup.chargeback_date | date }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Rep</span>
            <span class="info-value">{{ dup.rep | titlecase }}</span>
          </div>
        </nz-card>
      </div>
    </nz-card>
  </ng-container>
</div>

<nz-modal [(nzVisible)]="discrepancyModal" nzTitle="Discrepancy Notes" (nzOnCancel)="discrepancyModal = false"
  (nzOnOk)="submitDiscrepancy()">
  <ng-container *nzModalContent>
    <textarea nz-input [(ngModel)]="discrepancy_note" placeholder="Tell us what happened..."></textarea>
  </ng-container>
</nz-modal>

<nz-modal [nzOkLoading]="noteLoading" [(nzVisible)]="noteModal" nzTitle="New Note" (nzOnCancel)="cancelNote()"
  (nzOnOk)="submitNote()">
  <ng-container *nzModalContent>
    <textarea nz-input [formControl]="newNoteControl" maxlength="250"
      placeholder="Drop a quick note (250 char max)"></textarea>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="chargeModalVisible" nzTitle="Charge Processing Fee" (nzOnCancel)="closeChargeModal()"
  [nzFooter]="chargeFooter">
  <ng-container *nzModalContent>
    <div *ngIf="chargeSelectedWo">
      <div style="margin-bottom: 12px;">
        <div><strong>Customer:</strong> {{ customer?.first_name | titlecase }} {{ customer?.last_name | titlecase }}</div>
        <div><strong>Provider:</strong> {{ chargeSelectedWo.provider | titlecase }}</div>
        <div><strong>Order ID:</strong> {{ chargeSelectedWo.order_id || 'N/A' }}</div>
        <div><strong>Processing Fee:</strong> {{ chargeFeeDisplay || '$0.00' }}</div>
        <div *ngIf="chargeSelectedWo?.generic?.processingFeeInfo?.processingFeeDate">
          <strong>Fee Date:</strong> {{ chargeSelectedWo?.generic?.processingFeeInfo?.processingFeeDate | date:'mediumDate' }}
        </div>
      </div>

      <div *ngIf="chargeCardOptions?.length; else noCardOptions" style="margin-bottom: 12px;">
        <div style="margin-bottom: 6px;"><strong>Select Card:</strong></div>
        <nz-radio-group [(ngModel)]="chargeSelectedCardId" (ngModelChange)="onCardSelectionChange($event)">
          <label nz-radio *ngFor="let card of chargeCardOptions" [nzValue]="card.authorizePaymentId">
            Card ending {{ card.cardLast4 || '••••' }}
          </label>
        </nz-radio-group>
      </div>
      <ng-template #noCardOptions>
        <div *ngIf="chargeSelectedCardId; else noCardsAvailable" style="margin-bottom: 12px;">
          <strong>Payment Profile:</strong> {{ chargeSelectedCardId }}
        </div>
      </ng-template>
      <ng-template #noCardsAvailable>
        <div style="margin-bottom: 12px;">No saved cards found for this customer.</div>
      </ng-template>

      <div *ngIf="getAttemptHistory(chargeSelectedWo).length" style="margin-top: 8px;">
        <div style="margin-bottom: 6px;"><strong>Attempt History</strong></div>
        <ul style="margin:0; padding-left: 18px;">
          <li *ngFor="let attempt of getAttemptHistory(chargeSelectedWo)">
            {{ attempt?.dateAttempted | date: 'M/d, y, h:mm a' }} — {{ attempt?.result || 'unknown' }}<span *ngIf="attempt?.repName"> by {{ attempt?.repName | titlecase }}</span>
          </li>
        </ul>
      </div>
    </div>
  </ng-container>
  <ng-template #chargeFooter>
    <button nz-button nzType="default" (click)="closeChargeModal()" [disabled]="chargeLoading">Cancel</button>
    <button nz-button nzType="primary" (click)="confirmChargeProcessingFee()" [disabled]="chargeLoading || !chargeSelectedCardId">Charge</button>
  </ng-template>
</nz-modal>

<nz-modal [(nzVisible)]="dishNotesModal" nzTitle="Dish Notes" (nzOnCancel)="dishNotesModal = false" [nzFooter]="null">
  <ng-container *nzModalContent>
    <div *ngIf="dishNotes?.length; else noDishNotes">
      <div class="dish-note-card" *ngFor="let note of dishNotes">
        <h4>{{ formatDishNoteDate(note) }}</h4>
        <p>{{ note?.Note !== 'NULL' ? note?.Note : 'No note text provided' }}</p>
      </div>
    </div>
    <ng-template #noDishNotes>
      <p>No notes returned from Dish.</p>
    </ng-template>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="dishPricingModal" nzTitle="Dish Pricing" (nzOnCancel)="dishPricingModal = false"
  [nzFooter]="null">
  <ng-container *nzModalContent>
    <div *ngIf="dishPricing?.length; else noDishPricing">
      <div class="dish-pricing-card" *ngFor="let category of dishPricing">
        <div class="dish-pricing-head">
          <div>
            <p class="muted-text">Category</p>
            <h4>{{ category?.CategoryName || 'N/A' }}</h4>
          </div>
          <span class="dish-pricing-total">
            {{ category?.CategoryTotal | currency:'USD':'symbol':'1.2-2' }}
          </span>
        </div>
        <div class="dish-pricing-products" *ngIf="category?.Products?.length">
          <div class="dish-pricing-product" *ngFor="let product of category?.Products">
            <span>{{ product?.ProductName || 'Unnamed product' }}</span>
            <span class="dish-pricing-price">
              {{ product?.Price | currency:'USD':'symbol':'1.2-2' }}
            </span>
          </div>
        </div>
        <p class="muted-text" *ngIf="!category?.Products?.length">No line items for this category.</p>
      </div>
    </div>
    <ng-template #noDishPricing>
      <p>No pricing info returned from Dish.</p>
    </ng-template>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="editModal" nzTitle="Edit Work Order" (nzOnCancel)="editModal = false" [nzFooter]="editModalFooter">
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="editForm" [nzLayout]="'vertical'" nzNoColon class="edit-form">
      <nz-row [nzGutter]="16" class="edit-form__row">
        <nz-col [nzSpan]="12" class="edit-form__col">
          <nz-form-item class="edit-form__item">
            <nz-form-label nzFor="saleDate">Sale Date</nz-form-label>
            <nz-form-control>
              <nz-date-picker id="saleDate" formControlName="saleDate"
                nzPlaceHolder="Select sale date"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col [nzSpan]="12" class="edit-form__col">
          <nz-form-item class="edit-form__item">
            <nz-form-label nzFor="installDate">Install Date</nz-form-label>
            <nz-form-control>
              <nz-date-picker id="installDate" formControlName="installDate"
                nzPlaceHolder="Select install date"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>

      <nz-row [nzGutter]="16" class="edit-form__row">
        <nz-col [nzSpan]="12" class="edit-form__col">
          <nz-form-item class="edit-form__item">
            <nz-form-label nzFor="cancelDate">Cancel Date</nz-form-label>
            <nz-form-control>
              <nz-date-picker id="cancelDate" formControlName="cancelDate"
                nzPlaceHolder="Select cancel date"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col [nzSpan]="12" class="edit-form__col">
          <nz-form-item class="edit-form__item">
            <nz-form-label nzFor="chargebackDate">Chargeback Date</nz-form-label>
            <nz-form-control>
              <nz-date-picker id="chargebackDate" formControlName="chargebackDate"
                nzPlaceHolder="Select chargeback date"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>

      <nz-row [nzGutter]="16" class="edit-form__row">
        <nz-col [nzSpan]="12" class="edit-form__col">
          <nz-form-item class="edit-form__item">
            <nz-form-label nzFor="status">Status</nz-form-label>
            <nz-form-control>
              <input nz-input id="status" formControlName="status" placeholder="Status" />
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col [nzSpan]="12" class="edit-form__col">
          <nz-form-item class="edit-form__item">
            <nz-form-label nzFor="orderId">Order ID</nz-form-label>
            <nz-form-control>
              <input nz-input id="orderId" formControlName="orderId" placeholder="Order ID" />
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>

      <nz-row [nzGutter]="16" class="edit-form__row">
        <nz-col [nzSpan]="12" class="edit-form__col">
          <nz-form-item class="edit-form__item">
            <nz-form-control class="edit-form__checkbox">
              <label nz-checkbox formControlName="raf">RAF</label>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col [nzSpan]="12" class="edit-form__col">
          <nz-form-item class="edit-form__item">
            <nz-form-control class="edit-form__checkbox">
              <label nz-checkbox formControlName="noSync">No Sync</label>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>
    </form>
  </ng-container>
  <ng-template #editModalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">Cancel</button>
    <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="editSaveLoading"
      [disabled]="editForm.pristine || editForm.invalid || editSaveLoading">Save</button>
  </ng-template>
</nz-modal>

<nz-modal [(nzVisible)]="waiveModal" nzTitle="Waive Processing Fee" nzOkText="Confirm Waive" nzOkDanger="true"
    (nzOnCancel)="closeWaiveModal()" (nzOnOk)="submitWaive()">
  <ng-container *nzModalContent>
    <div *ngIf="selectedWo">
      <div style="margin-bottom: 12px;">
        <p><strong>Are you sure you want to waive this processing fee?</strong></p>
        <div><strong>Provider:</strong> {{ selectedWo.provider | titlecase }}</div>
        <div><strong>Order ID:</strong> {{ selectedWo.order_id || 'N/A' }}</div>
        <div *ngIf="selectedWo.generic?.processingFee"><strong>Processing Fee:</strong> {{ selectedWo.generic.processingFee }}</div>
        <div *ngIf="selectedWo.status"><strong>Status:</strong> {{ selectedWo.status | titlecase }}</div>
      </div>
      <p style="color: #ff4d4f; margin-top: 12px;">This action will set the processing fee to $0.00 and mark the order as waived.</p>
    </div>
  </ng-container>
</nz-modal>
